export default {
  adjustIndex (array, index) {
    // make sure array index is inside the array
    if (Array.isArray(array)) {
      const length = array.length
      if (index < 0) {
        return index + length
      }
      if (index >= length) {
        return index - length
      }
    }
    return index
  },
  cssBackground (elementId, asset) {
    // set the background for #[elementId] using src/assets/img/[asset]
    const assetPath = require('../img/' + asset)
    const element = document.getElementById(elementId)
    if (element) {
      element.style.backgroundImage = 'url(' + assetPath + ')'
    } else {
      console.log('element with id ' + elementId + ' does not exist')
    }
  },
  findObjectForKey (array, key) {
    // given an array of objects, find the object whose first key is [key]
    var object = null
    if (array !== null && key !== null) {
      array.forEach((item) => {
        if (this.firstKeyOf(item) === key) {
          object = item[key]
        }
      })
    }
    return object
  },
  firstKeyOf (object) {
    // given an object, return the first key
    if (object !== null) {
      const firstKey = Object.keys(object)[0]
      if (firstKey === '0') {
        return object
      }
      return firstKey
    }
    return null
  },
  indexOfKeyIn (array, key) {
    // given an array of objects, find the index of the object whose first key is [key]
    var index = -1
    if (Array.isArray(array)) {
      array.forEach((item, currentIndex) => {
        if (this.firstKeyOf(item) === key) {
          index = currentIndex
        }
      })
    }
    return index
  },
  keyOfFirstOf (array) {
    // return the first key of the first object in the given array
    if (Array.isArray(array) && array.length > 0) {
      return this.firstKeyOf(array[0])
    }
    return null
  },
  setStyle (element, property, value) {
    // given a DOM element, set the style [property] to [value]
    element.style[property] = value
  },
  setStyleById (elementId, property, value) {
    // given #[elementId] set the style [property] to [value]
    this.setStyle(document.getElementById(elementId), property, value)
  },
  staticPrefix () {
    // this method fixes resource paths under src/assets that work in dev & break in prod
    // adjust path for development mode
    var prefix = '.'
    // NODE_ENV is injected by webpack
    if (process.env.NODE_ENV === 'development') {
      prefix = '../..'
    }
    return prefix + '/'
  }
}
